import React, { useSyncExternalStore } from "react";
import { FilterContext } from "./FilterContext";
export function useFilterStore(fields) {
    var store = React.useContext(FilterContext);
    var data = useSyncExternalStore(function(callback) {
        return store.subscribe(callback, fields);
    }, function() {
        return store.getState();
    }, function() {
        return store.getState();
    });
    return {
        data: data,
        setFilterState: store.setState,
        clearAllFilters: store.clearAllFilters
    };
}
